import { branchService } from '@/app/[locale]/_service/branch.service'
import { IRedux } from '@/app/[locale]/_store/types'
import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearOrderIds,
  clearBranchData,
} from '@/app/[locale]/_store/common/common.slice'
import { useSaveBranchData } from '@/app/[locale]/_hooks/useSaveBranchData'

export default function useDelivery({ enabled = true }: { enabled?: boolean }) {
  const { order_type } = useSelector((state: IRedux) => state.session)
  const commonState = useSelector((state: IRedux) => state.common)
  const dispatch = useDispatch()
  const saveBranch = useSaveBranchData()

  const findNearestBranch = useCallback(
    async ({ lat, long }: { lat: number; long: number }) => {
      try {
        const result = await branchService.findNearest({
          lat,
          long,
          order_type_id: order_type?.id,
          delivery_zone_id: commonState?.deliveryZone?.id || '',
        })

        if (result?.data?.branches) {
          for (let nearestBranch of result.data?.branches) {
            if (nearestBranch?.is_active) {
              return nearestBranch
            }
          }
        }
      } catch (error) {
        console.log(error)
        return
      }
    },
    [order_type?.id, commonState?.deliveryZone?.id]
  )

  const activePoint = useMemo(() => {
    // Only calculate if we're in delivery mode and have points
    if (order_type?.type === 'delivery' && commonState?.points?.length > 0) {
      // Find the first active point
      const active = commonState.points.find((point) => point?.isActive)

      if (active?.location) {
        return {
          lat: active.location[0] ?? 0,
          long: active.location[1] ?? 0,
        }
      }
    }

    return null
  }, [commonState?.points, order_type?.type])

  useEffect(() => {
    const fetchNearestBranch = async () => {
      if (activePoint?.lat && activePoint?.long) {
        const nearestBranch = await findNearestBranch(activePoint)

        if (nearestBranch && nearestBranch?.id) {
          saveBranch({
            id: nearestBranch.id,
            menu_id: nearestBranch.menu_id || '',
            address: nearestBranch.address,
            name: nearestBranch.name,
            location: nearestBranch.location,
            slug: nearestBranch.slug,
            future_delivery_order_time:
              nearestBranch.future_delivery_order_time,
            future_self_pickup_order_time:
              nearestBranch.future_self_pickup_order_time,
            delivery_time: nearestBranch.delivery_time,
            work_hour_start: nearestBranch.work_hour_start,
            work_hour_end: nearestBranch.work_hour_end,
            is_work_24_7: nearestBranch.is_work_24_7,
          })
        } else {
          dispatch(clearBranchData())
        }
      }
    }
    if (commonState?.orderIds) {
      //clear ordersid this need code connection offhours predorder modal open or close
      dispatch(clearOrderIds())
    }

    if (enabled) {
      fetchNearestBranch()
    }
  }, [activePoint, commonState?.deliveryZone?.id, saveBranch, dispatch])

  return {}
}
